// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_ex-0";